import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Facebook, Instagram } from 'lucide-react';
import { Button } from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Programs',
    path: '/programs'
  }, {
    name: 'Schedule',
    path: '/schedule'
  }, {
    name: 'Staff',
    path: '/staff'
  }, {
    name: 'Gallery',
    path: '/gallery'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <motion.nav initial={false} animate={{
    height: isScrolled ? 'auto' : 'auto'
  }} className={`fixed top-0 left-0 right-0 z-50 bg-white transition-shadow duration-300 ${isScrolled ? 'shadow-lg' : 'shadow-sm'}`} data-id="element-226">
      {/* Desktop Header */}
      <div className="hidden lg:block" data-id="element-227">
        <AnimatePresence mode="wait" data-id="element-228">
          {!isScrolled ? <motion.div key="full-header" initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.2
        }} data-id="element-229">
              {/* Top Row */}
              <div className="border-b border-gray-100" data-id="element-230">
                <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
                  <div className="flex items-center justify-between py-6" data-id="element-232">
                    {/* Left: Local SEO Statement */}
                    <div className="flex-1" data-id="element-233">
                      <p className="text-sm text-gray-600 font-medium" data-id="element-234">
                        Family-Focused Taekwondo in Brighton, Michigan
                      </p>
                    </div>

                    {/* Center: Logo */}
                    <Link to="/" className="group absolute left-1/2 transform -translate-x-1/2" data-id="element-235">
                      <img src="https://cdn.magicpatterns.com/uploads/4uEVqdedai1eG84tAbHxGF/logo.png" alt="Limitless Taekwondo" className="h-20 w-auto transition-transform group-hover:scale-105" data-id="element-236" />
                    </Link>

                    {/* Right: Phone & Social */}
                    <div className="flex-1 flex items-center justify-end gap-4" data-id="element-237">
                      <a href="tel:8107753153" className="flex items-center gap-2 text-gray-700 hover:text-primary transition-colors group" data-id="element-238">
                        <Phone className="w-4 h-4" data-id="element-239" />
                        <span className="font-semibold" data-id="element-240">(810) 775-3153</span>
                      </a>
                      <div className="flex items-center gap-2 ml-2" data-id="element-241">
                        <a href="https://www.facebook.com/Limitlessmartialart/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors" aria-label="Facebook" data-id="element-242">
                          <Facebook className="w-5 h-5" data-id="element-243" />
                        </a>
                        <a href="https://instagram.com/LimitlessMA" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors" aria-label="Instagram" data-id="element-244">
                          <Instagram className="w-5 h-5" data-id="element-245" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bottom Row */}
              <div className="py-4" data-id="element-246">
                <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
                  <div className="flex items-center justify-between" data-id="element-248">
                    {/* Centered Navigation */}
                    <div className="flex-1 flex items-center justify-center gap-8" data-id="element-249">
                      {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary relative ${location.pathname === link.path ? 'text-primary' : 'text-gray-700'}`} data-id="element-250">
                          {link.name}
                          {location.pathname === link.path && <motion.div layoutId="activeNav" className="absolute -bottom-1 left-0 right-0 h-0.5 bg-primary" transition={{
                      type: 'spring',
                      stiffness: 380,
                      damping: 30
                    }} data-id="element-251" />}
                        </Link>)}
                    </div>

                    {/* Right: CTA */}
                    <div className="flex-shrink-0" data-id="element-252">
                      <Link to="/trial" data-id="element-253">
                        <Button variant="primary" size="sm" data-id="element-254">
                          4-Week Trial
                        </Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div> : <motion.div key="compact-header" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2
        }} className="py-3" data-id="element-255">
              <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
                <div className="flex items-center justify-between" data-id="element-257">
                  {/* Left: Logo - Using custom height for 60px (50% larger than 40px) */}
                  <Link to="/" className="group flex-shrink-0" data-id="element-258">
                    <img src="https://cdn.magicpatterns.com/uploads/4uEVqdedai1eG84tAbHxGF/logo.png" alt="Limitless Taekwondo" className="w-auto transition-transform group-hover:scale-105" style={{
                  height: '60px'
                }} data-id="element-259" />
                  </Link>

                  {/* Center: Navigation */}
                  <div className="flex-1 flex items-center justify-center gap-6" data-id="element-260">
                    {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-primary ${location.pathname === link.path ? 'text-primary' : 'text-gray-700'}`} data-id="element-261">
                        {link.name}
                      </Link>)}
                  </div>

                  {/* Right: CTA */}
                  <div className="flex-shrink-0" data-id="element-262">
                    <Link to="/trial" data-id="element-263">
                      <Button variant="primary" size="sm" data-id="element-264">
                        4-Week Trial
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>

      {/* Mobile Header */}
      <div className="lg:hidden" data-id="element-265">
        <div className="px-4 py-4" data-id="element-266">
          <div className="flex items-center justify-between" data-id="element-267">
            {/* Logo */}
            <Link to="/" className="group" data-id="element-268">
              <img src="https://cdn.magicpatterns.com/uploads/4uEVqdedai1eG84tAbHxGF/logo.png" alt="Limitless Taekwondo Logo" className="h-10 w-auto transition-transform group-hover:scale-105" data-id="element-269" />
            </Link>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-600 hover:text-primary focus:outline-none" aria-label="Toggle menu" data-id="element-270">
              {isOpen ? <X className="h-6 w-6" data-id="element-271" /> : <Menu className="h-6 w-6" data-id="element-272" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <AnimatePresence data-id="element-273">
          {isOpen && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="bg-white border-t border-gray-100 overflow-hidden" data-id="element-274">
              <div className="px-4 pt-2 pb-6 space-y-2" data-id="element-275">
                {/* Phone & Social */}
                <div className="flex items-center justify-between py-3 border-b border-gray-100 mb-2" data-id="element-276">
                  <a href="tel:8107753153" className="flex items-center gap-2 text-gray-700 hover:text-primary transition-colors" data-id="element-277">
                    <Phone className="w-4 h-4" data-id="element-278" />
                    <span className="font-semibold text-sm" data-id="element-279">
                      (810) 775-3153
                    </span>
                  </a>
                  <div className="flex items-center gap-3" data-id="element-280">
                    <a href="https://www.facebook.com/Limitlessmartialart/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors" aria-label="Facebook" data-id="element-281">
                      <Facebook className="w-5 h-5" data-id="element-282" />
                    </a>
                    <a href="https://instagram.com/LimitlessMA" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-primary transition-colors" aria-label="Instagram" data-id="element-283">
                      <Instagram className="w-5 h-5" data-id="element-284" />
                    </a>
                  </div>
                </div>

                {navLinks.map(link => <Link key={link.name} to={link.path} className={`block px-3 py-2 rounded-md text-base font-medium ${location.pathname === link.path ? 'bg-blue-50 text-primary' : 'text-gray-600 hover:bg-gray-50 hover:text-primary'}`} data-id="element-285">
                    {link.name}
                  </Link>)}
                <div className="pt-4" data-id="element-286">
                  <Link to="/trial" className="block w-full" data-id="element-287">
                    <Button variant="primary" fullWidth data-id="element-288">
                      Get 4-Week Trial
                    </Button>
                  </Link>
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.nav>;
}